import styles from "../GameScreen.module.scss";
import {GameScreenHeaderProps} from "../../../types/props";
import {GameState} from "../../../types/game";

const GameScreenHeader = ({
                              game,
                              lobby,
                              yourTurn,
                              currentPlayerUserName,
                              handleLeave
                          }: GameScreenHeaderProps) => {
        const {gameData} = game;

        const isGameGoing = game.state === GameState.MAIN_PLAY;

        return (
            <div className={styles.gameScreen__header}>
                <div className={styles.gameScreen__info}>
                    <h1 className={styles.gameScreen__title}>{`${lobby.title}: Game #${lobby.gamesPlayed + 1}`}</h1>
                    <div className={styles.gameScreen__meta}>
                        <span>Turn: {gameData.turn + 1}</span>
                        {isGameGoing && currentPlayerUserName && (
                            <span>
                                Current player: <strong>{currentPlayerUserName}</strong>
                            </span>
                        )}
                    </div>
                </div>

                <div className={styles.gameScreen__controls}>
                    {isGameGoing && (
                        <div className={styles.gameScreen__turnInfo}>
                        <span
                            className={`${styles.gameScreen__pill} ${
                                yourTurn
                                    ? styles["gameScreen__pill--success"]
                                    : styles["gameScreen__pill--muted"]
                            }`}
                        >
                            {yourTurn ? "Your turn" : "Waiting for others"}
                        </span>
                        </div>
                    )}
                    <button
                        className={`${styles.gameScreen__btn} ${styles["gameScreen__btn--ghost"]}`}
                        onClick={handleLeave}
                    >
                        Leave game
                    </button>
                </div>
            </div>
        );
    }
;

export default GameScreenHeader;
